import { Record, type RecordOf } from 'immutable';

import type { QcsSyncResourceStore } from 'app-components/flux/core/resourceStoreTypes';
import { resourceStoreTypes } from '../core';

export const PROJECTS_REDUCER_KEY = 'projectsStore';
export type ProjectsStore = QcsSyncResourceStore<ProjectProps>;
export const mkProjectsStore = resourceStoreTypes.createTypedQcsSyncResourceStoreFactory<ProjectProps>();

export type ProjectStatus = 'NOT_STARTED' | 'IN_PROGRESS' | 'COMPLETED' | 'PAST_DUE';

export type ProjectProps = {
  id?: string;
  clientId?: string;
  createdAt?: string;
  name?: string;
  description?: string;
  status?: ProjectStatus;
  customerId?: string;
  businessId?: string;
  dueOn?: string | null;
  isDeleted?: boolean;
  completedOn?: string;
  attachmentIds?: string[];
};

export type Project = RecordOf<ProjectProps>;

export const mkProject = Record<ProjectProps>({
  id: undefined,
  clientId: undefined,
  createdAt: undefined,
  name: undefined,
  description: undefined,
  status: undefined,
  customerId: undefined,
  businessId: undefined,
  dueOn: undefined,
  isDeleted: undefined,
  completedOn: undefined,
  attachmentIds: undefined,
});

declare module 'app-components/utils/redux-store/rootState' {
  export default interface RootState {
    [PROJECTS_REDUCER_KEY]: QcsSyncResourceStore<ProjectProps>;
  }
}
